import { CouponIssuedItem } from "../interfaces/coupon-issued-item.interface";

export const COUPON_CATEGORY0: CouponIssuedItem = {
    name: "전체",
    depth: 1,
};

export const COUPON_CATEGORY1: CouponIssuedItem = {
    name: "검사도구",
    depth: 1,
    children: [
        {
            name: "전체",
            depth: 2,
        },
        {
            name: "LP검사",
            depth: 2,
        },
    ],
} as const;

export const COUPON_CATEGORY2: CouponIssuedItem = {
    name: "스토어",
    depth: 1,
    children: [
        {
            name: "전체",
            depth: 2,
        },
        {
            name: "디지털자료",
            depth: 2,
        },
        {
            name: "교구",
            depth: 2,
            invisible: true,
        },
        {
            name: "교재",
            depth: 2,
            invisible: true,
        },
    ],
} as const;

export const COUPON_CATEGORY3: CouponIssuedItem = {
    name: "토큰",
    depth: 1,
} as const;

/**
 * @name COUPON_ISSUED_ITEMS
 * @description 발행 품목 목록 (대중소 분류 총 3depth)
 */
export const COUPON_ISSUED_ITEMS: CouponIssuedItem[] = [
    COUPON_CATEGORY0,
    COUPON_CATEGORY1,
    COUPON_CATEGORY2,
    COUPON_CATEGORY3,
];
